/**
 * Supabase URL and anon key from Vite. `VITE_*` values are **statically replaced at build time**
 * (`vite build`), including on Cloudflare Pages — they must exist in the **build** environment, not only as runtime Worker secrets.
 *
 * Cloudflare Pages: Settings → Environment variables → add for **Production** / **Preview** (used during `npm run build`).
 */

const rawUrl = import.meta.env.VITE_SUPABASE_URL
const rawKey = import.meta.env.VITE_SUPABASE_ANON_KEY

export const supabaseUrl = typeof rawUrl === 'string' ? rawUrl.trim() : ''
export const supabaseAnonKey = typeof rawKey === 'string' ? rawKey.trim() : ''

if (!supabaseUrl || !supabaseAnonKey) {
  // Vite replaces each `import.meta.env.VITE_*` with a string literal at build time; the runtime object
  // often only shows built-in keys (MODE, BASE_URL, …), so `viteKeys` here is usually empty even when
  // the build had values. Empty strings here means those vars were **missing during `vite build`**.
  console.error('Vite import.meta.env (debug):', import.meta.env)
  console.error('Supabase env diagnostic:', {
    inlinedUrlLength: supabaseUrl.length,
    inlinedKeyLength: supabaseAnonKey.length,
    MODE: import.meta.env.MODE,
    note: 'If lengths are 0, Cloudflare did not pass VITE_SUPABASE_* into the build environment. Check Pages → Variables → Production (Plaintext), then redeploy.',
  })
  throw new Error(
    'Missing Supabase environment variables (VITE_SUPABASE_URL and/or VITE_SUPABASE_ANON_KEY). ' +
      'They were not available when `vite build` ran, so the bundle has empty values. ' +
      'Fix on Cloudflare Pages: Workers & Pages → **Pages** project → Settings → Environment variables → **Production** (and Preview if you use it), Plaintext, save, redeploy (clear build cache if needed).',
  )
}
